<script>
    let newGamePlayersCount = 5;
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    import { trainerTexts as texts } from './trainerTexts.js';
    export let lang;
</script>

<div class="section section--number-bar">
    <button
        class="btn"
        on:click={() =>
            dispatch('createGame', { players: newGamePlayersCount })}
    >
        <span class="btn-text__main">{texts[lang].create_game}</span>
    </button>
    <div class="btn-number">
        <button
            on:click={() => {
                if (newGamePlayersCount >= 6) newGamePlayersCount--;
            }}
        />
        <input type="number" min="5" max="8" bind:value={newGamePlayersCount} />
        <button
            on:click={() => {
                if (newGamePlayersCount <= 7) newGamePlayersCount++;
            }}
            class="plus"
        />
    </div>
    <button class="btn u-margin-top" on:click={() => dispatch('refresh')}>
        <span class="btn-text__main">{texts[lang].refresh}</span>
    </button>
</div>
